import { Breadcrumb, Input, Popconfirm, Row, Space, Table, Tooltip } from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { getRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { ReactComponent as ArchiveRestore } from "../../image/ArchiveRestore.svg";
import SearchIcon from "../../image/SearchIcon.svg";
import "../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";

const { Search } = Input;

const ArchivedRequestedDemoList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const colors = ["#094E8F"];
  const [reload, setReload] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [archivedRequestedDemoList, setArchivedRequestedDemoList] = useState(
    []
  );
  const [totalCount, settotalCount] = useState(0);

  // state iniatialisation
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  // Fetch Archived Requested Demo API
  useEffect(() => {
    const getArchivedRequestedDemoList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest("request-demo-archive/", state);

        if (apiResponse.data.results.success) {
          setArchivedRequestedDemoList(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_archive_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getArchivedRequestedDemoList();
  }, [state, reload, t]);

  // Function On Table Change
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };

  // function on Shorting  Enumvalue
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "name" && sortOrder === "ascend") {
      sortingEnumKey = "name";
    }
    if (sortField === "name" && sortOrder === "descend") {
      sortingEnumKey = "-name";
    }
    if (sortField === "company" && sortOrder === "ascend") {
      sortingEnumKey = "company";
    }
    if (sortField === "company" && sortOrder === "descend") {
      sortingEnumKey = "-company";
    }
    if (sortField === "phone_number" && sortOrder === "ascend") {
      sortingEnumKey = "phone_number";
    }
    if (sortField === "phone_number" && sortOrder === "descend") {
      sortingEnumKey = "-phone_number";
    }
    if (sortField === "email" && sortOrder === "ascend") {
      sortingEnumKey = "email";
    }
    if (sortField === "email" && sortOrder === "descend") {
      sortingEnumKey = "-email";
    }
    if (sortField === "no_of_buyer" && sortOrder === "ascend") {
      sortingEnumKey = "no_of_buyer";
    }
    if (sortField === "no_of_buyer" && sortOrder === "descend") {
      sortingEnumKey = "-no_of_buyer";
    }
    if (sortField === "about_company" && sortOrder === "ascend") {
      sortingEnumKey = "about_company";
    }
    if (sortField === "about_company" && sortOrder === "descend") {
      sortingEnumKey = "-about_company";
    }
    if (sortField === "request_date" && sortOrder === "ascend") {
      sortingEnumKey = "request_date";
    }
    if (sortField === "request_date" && sortOrder === "descend") {
      sortingEnumKey = "-request_date";
    }
    if (sortField === "demo_date" && sortOrder === "ascend") {
      sortingEnumKey = "demo_date";
    }
    if (sortField === "demo_date" && sortOrder === "descend") {
      sortingEnumKey = "-demo_date";
    }
    if (sortField === "day_count" && sortOrder === "ascend") {
      sortingEnumKey = "day_count";
    }
    if (sortField === "day_count" && sortOrder === "descend") {
      sortingEnumKey = "-day_count";
    }

    return sortingEnumKey;
  };

  // function Row Selection 
  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  // function for Restore Data
  const handleRestore = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("request-demo-archive/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("requested_demo_restore_successfully"));
        setReload(!reload);
        setSelectedRow([]);
        navigate("/requested-demo");
      } else {
        ErrorNotificationMsg(t("error_in_restore_requested_demo"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  // Function to handle the search input change with debounce
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  // Debounced function to delay the search execution
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  // Function to update state with the search value
  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const columns = [
    {
      title: "Client",
      dataIndex: "company",
      sorter: true,
      key: "company",
      width: "80",
    },
    {
      title: "Client Personnel",
      dataIndex: "name",
      key: "name",
      sorter: true,
      width: "80",
    },
    {
      title: "Contact number",
      dataIndex: "phone_number",
      sorter: true,
      key: "phone_number",
      width: "250",
      render: (phone_number) => <>+{phone_number} </>,
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: true,
      key: "email",
      width: "100",
    },
    {
      title: "Request Date",
      dataIndex: "request_date",
      sorter: true,
      key: "request_date",
      width: "80",
    },
    {
      title: "Demo Date",
      dataIndex: "demo_date",
      sorter: true,
      key: "demo_date",
      width: "120",
    },
    {
      title: "Buyer Count",
      dataIndex: "no_of_buyer",
      sorter: true,
      key: "no_of_buyer",
      width: "100",
    },

    {
      title: "Client Profile",
      dataIndex: "about_company",
      sorter: true,
      key: "about_company",
      width: "120",
    },

    {
      title: (
        <Tooltip
          color={colors}
          style={{ color: "#fff" }}
          title="Yet To Attend Aging"
        >
          YTA Aging
        </Tooltip>
      ),
      dataIndex: "day_count",
      key: "day_count",
    },
    {
      title: "Action",
      fixed: "right",
      width: "100px",
      key: "operation",
      render: (text, record) => (
        <Space>
          <Tooltip
            color={colors}
            placement="right"
            title={<span style={{ color: "#fff" }}>Restore</span>}
          >
            <Popconfirm
              className="action"
              title={t("pop_restore_title")}
              okText={t("pop_ok")}
              cancelText={t("pop_cancel")}
              onConfirm={() => handleRestore(record.id)}
            >
              <ArchiveRestore className="ArchiverestorImg" />{" "}
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Archived entries retain historical data and can be reinstated
                  if necessary.
                </span>
              }
            >
              <h3>{t("pl_archived_demo_request")}</h3>
            </Tooltip>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/requested-demo">{t("pl_demo_request")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("pl_archive1")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
              <Search
  value={searchText}
  onChange={(e) => {
    const value = e.target.value;
    setSearchText(value);
    debounceLoadData(value, onSearch);
  }}
  allowClear
  onSearch={(value) => {
    setSearchText(value);
    onSearch(value);
  }}
  prefix={
    <img
      src={SearchIcon}
      alt="SearchIcon"
      className="SearchIcon"
      width={22}
    />
  }
  placeholder={t("pl_search_list")}
  style={{ width: 250 }}
/>


              </Space>
            </div>
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleRestore()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label={t("pl_restore")}
                />
              </Popconfirm>
            )}
          </Space>
        </div>
      </div>

      <section className="grid-sec mt-5">
        <div className="PR-body">
          <Row className="tblheader">
          </Row>

          <Table
            scroll={{
              x: 2530,
            }}
            rowSelection={rowSelection}
            rowKey={(record) => record.id}
            columns={columns}
            dataSource={archivedRequestedDemoList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: "Items / Page", // Text for the size changer
              },
            }}
            onChange={handleTableChange}
          />
          <div className="FormFooter Container">
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("pl_back_to_list")}
              onClick={() => navigate(`/requested-demo`)}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default ArchivedRequestedDemoList;
